// use variable at localStorage.getItem('seed_shopify_cart_full_info') for fullShopifyCart;

export const getCouponType = (
  fullShopifyCart: any,
): 'fixed' | 'percent' | undefined => {
  // cart-level discount allocations (ie bundle coupon)
  for (const allocation of fullShopifyCart?.discountAllocations || []) {
    if (allocation?.discountApplication?.value?.percentage !== undefined) {
      return 'percent';
    }
    if (allocation?.discountApplication?.value?.amount !== undefined) {
      return 'fixed';
    }
  }

  // line-item discount allocations (typical promo codes)
  for (const line of fullShopifyCart?.lines?.nodes || []) {
    for (const allocation of line?.discountAllocations || []) {
      if (allocation?.discountApplication?.value?.percentage !== undefined) {
        return 'percent';
      }
      if (allocation?.discountApplication?.value?.amount !== undefined) {
        return 'fixed';
      }
    }
  }
};
